import { FrontEndError } from '@pya-mms/common';
import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { Contact } from '../../../constants';
import { useError } from '../../../utils/hooks/useError';
import { SaveButton } from '../Button';
import Status from './status';

interface ErrorComponentProps extends FrontEndError {
  customTitle?: string;
  customDescription?: string[];
}

const ErrorComponent: React.FC<ErrorComponentProps> = ({
  errorMessage,
  errorFunction,
  token,
  customTitle,
  customDescription,
}: ErrorComponentProps) => {
  const { addError } = useError();
  const { mutateAsync: addErrorMutation } = useMutation(addError);

  useEffect(() => {
    addErrorMutation({ errorMessage, errorFunction, token });
  }, [errorMessage, errorFunction, token]);

  const handleEmailClick = () => {
    window.location.href = `mailto:${Contact.EMAIL}?subject=Error%20Report&body=Please%20provide%20more%20details`;
  };

  return (
    <Status
      status="Error"
      title={customTitle || 'Oops! Something went wrong'}
      description={
        customDescription || [
          "We're sorry, but the following error occurred while processing your request. Our team has been notified, but please feel free to contact us directly.",
          errorMessage,
        ]
      }
      buttons={[<SaveButton title="Contact Support" onClick={handleEmailClick} key={`contact-support-error`} />]}
    />
  );
};
export default ErrorComponent;
